import { Routes, Route, Navigate } from "react-router-dom";



 import InternationalExpress from "./InternationalExpress";

const internationalExpressRoutes = [

    {routeName: 'redbox' , component: <InternationalExpress/>},
    {routeName: 'express-flyer' , component: <InternationalExpress/>},
    {routeName: 'student-express' , component: <InternationalExpress/>},
    {routeName: 'attestation-services' , component: <InternationalExpress/>},

];

const InternationalExpressRoutes = () => {
    return (
    <Routes>
       {internationalExpressRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default InternationalExpressRoutes;